export default __webpack_public_path__ + "static/media/frank_oberklaid.884b773d.jpg";